import React from 'react';
import { CheckCircle } from '@mui/icons-material';

const IntegrationSidebar = ({ steps, activeStep, activeIndex = 0, onStepChange }) => {
    return (
        <nav className="sticky top-24 bg-white rounded-2xl shadow-lg border border-amber-100/50 p-6">
            <div className="mb-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">Guide d'Intégration</h3>
                <p className="text-sm text-gray-600">Suivez les étapes dans l'ordre</p>
            </div>

            <ul className="space-y-2">
                {steps.map((step, index) => (
                    <li key={step.id}>
                        {(() => {
                            const isActive = activeStep === step.id;
                            const isDone = index < activeIndex;
                            const Icon = step.Icon;
                            return (
                        <button
                            onClick={() => onStepChange(step.id)}
                            className={`w-full text-left p-4 rounded-xl transition-all duration-300 group ${
                                isActive
                                    ? 'bg-gradient-to-r from-amber-100 to-yellow-100 border-2 border-amber-200 shadow-md'
                                    : 'border border-transparent hover:border-amber-200 hover:bg-amber-50/50'
                            }`}
                        >
                            <div className="flex items-center space-x-3">
                                <div className={`flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center text-lg ${
                                    isActive
                                        ? 'bg-gradient-to-r from-amber-500 to-yellow-500 text-white'
                                        : isDone
                                            ? 'bg-emerald-100 text-emerald-700'
                                            : 'bg-amber-100 text-amber-600'
                                }`}>
                                    {isDone ? (
                                        <CheckCircle fontSize="small" />
                                    ) : Icon ? (
                                        <Icon fontSize="small" />
                                    ) : null}
                                </div>
                                <div className="flex-1 min-w-0">
                                    <div className="flex items-center justify-between">
                                        <span className={`font-semibold text-sm ${
                                            isActive ? 'text-amber-700' : isDone ? 'text-emerald-700' : 'text-gray-700'
                                        }`}>
                                            {step.title}
                                        </span>
                                        <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded-full">
                                            {step.duration}
                                        </span>
                                    </div>
                                    <div className="flex items-center space-x-2 mt-1">
                                        <div className={`w-2 h-2 rounded-full ${
                                            isActive ? 'bg-amber-500' : isDone ? 'bg-emerald-500' : 'bg-gray-300'
                                        }`}></div>
                                        <span className="text-xs text-gray-500">
                                            Étape {index + 1} sur {steps.length}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </button>
                            );
                        })()}
                    </li>
                ))}
            </ul>

            {/* Progress Bar */}
            <div className="mt-8 pt-6 border-t border-gray-200">
                <div className="flex items-center justify-between mb-2">
                    <span className="text-sm font-medium text-gray-700">Progression</span>
                    <span className="text-sm text-amber-600 font-semibold">
                        {Math.round((steps.findIndex(step => step.id === activeStep) + 1) / steps.length * 100)}%
                    </span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                    <div
                        className="bg-gradient-to-r from-amber-500 to-yellow-500 h-2 rounded-full transition-all duration-500"
                        style={{ width: `${(steps.findIndex(step => step.id === activeStep) + 1) / steps.length * 100}%` }}
                    ></div>
                </div>
            </div>

            {/* Quick Help */}
            <div className="mt-6 p-4 bg-amber-50 rounded-lg border border-amber-200">
                <h4 className="font-semibold text-amber-800 text-sm mb-2">Besoin d'aide ?</h4>
                <p className="text-amber-700 text-xs">
                    Contactez notre support technique pour une assistance personnalisée.
                </p>
                <button className="mt-2 text-xs text-amber-600 hover:text-amber-700 font-medium">
                    Contact support →
                </button>
            </div>
        </nav>
    );
};

export default IntegrationSidebar;